<template>
  <div class="l-container">
    <!-- <div>{{obj}}</div> -->

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>
    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">タグ名</btn>
        <btn class="m-btn--column" @click.native="switchV('color')" v-bind:class="{ 'active': color }">色</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <div style="display: flex">
      <button @click="postTag" style="width: 150px"><i class="fa fa-fw fa-plus"></i></button>
      <input v-model="add.name" type="text" placeholder="タグ名" style="border: solid 1px #ccc; width: 150px; margin: 1px; padding: 10px">
      <input @click="chrome" v-model="tag_color" type="text" placeholder="色" v-bind:style="{ 'backgroundColor': tag_color }" style="border: solid 1px #ccc; width: 150px; margin: 1px; padding: 10px; color: #fff; cursor: pointer">
      <chrome-picker v-model="colors" @change-color="onChange" v-show="condition" style="position: absolute; left: 694px">Chrome-picker</chrome-picker>
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">検索</td-c>
          <template v-if="id"><td-c><input v-model="search.id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="color"><td-c><input v-model="search.color" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c></td-c>
          <td-c style="text-align: center">除外検索</td-c>
          <template v-if="id"><td-c><input v-model="search.not_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="name"><td-c><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="color"><td-c><input v-model="search.not_color" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="created_at"><td-c><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c style="text-align: center">削除</th-c>
          <th-c style="text-align: center">編集</th-c>
          <template v-if="id"><th-c @click.native='sort("id")'>ID</th-c></template>
          <template v-if="name"><th-c @click.native='sort("name")'>タグ名</th-c></template>
          <template v-if="color"><th-c @click.native='sort("color")'>色</th-c></template>
          <template v-if="created_at"><th-c @click='sort("created_at")'>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="(list, index) in orderedTags" :key="index.id">
          <template v-if="list.id == edit_id.edit_id">
            <td-c @click.native="cancelTag(list)" class="del" style="position: relative">戻る</td-c>
            <td-c @click.native="patchTag(list)" class="del" style="position: relative">更新</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="name"><td-c style="border: solid 3px #41B883"><input type="text" v-model="list.name" style="font-weight: bold"></td-c></template>
            <template v-if="color">
              <td-c v-bind:style="{ 'backgroundColor': list.color }">
                <input @click="chrome2" v-model="list.color" type="text" v-bind:style="{ 'backgroundColor': list.color }" style="color: #fff; cursor: pointer">
                <chrome-picker v-model="list.color" @change-color="onChange2($event, list)" v-show="condition2" style="position: absolute; left: 694px">Chrome-picker</chrome-picker>
              </td-c>
            </template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
          <template v-if="list.id !== edit_id.edit_id">
            <td-c @click.native="deleteTag(list)" class="del" style="position: relative">削除</td-c>
            <td-c @click.native="editTag(list)" class="del" style="position: relative">編集</td-c>
            <template v-if="id"><td-c>{{list.id}}</td-c></template>
            <template v-if="name"><td-c>{{list.name}}</td-c></template>
            <template v-if="color"><td-c v-bind:style="{ 'backgroundColor': list.color }" style="color: #fff">{{list.color}}</td-c></template>
            <template v-if="created_at"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
          </template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/tags/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'tag',
  pageNames: 'tags'
}

var defaultProps = {
  hex: '#24C776',
  hsl: {
    h: 150,
    s: 0.5,
    l: 0.2,
    a: 1
  },
  hsv: {
    h: 150,
    s: 0.66,
    v: 0.30,
    a: 1
  },
  rgba: {
    r: 25,
    g: 77,
    b: 51,
    a: 1
  },
  a: 1
}
var defaultProps2 = {
  hex: '#24C776',
  hsl: {
    h: 150,
    s: 0.5,
    l: 0.2,
    a: 1
  },
  hsv: {
    h: 150,
    s: 0.66,
    v: 0.30,
    a: 1
  },
  rgba: {
    r: 25,
    g: 77,
    b: 51,
    a: 1
  },
  a: 1
}

let _ = window._
export default {
  data () {
    return {
      condition: false,
      condition2: false,
      colors: defaultProps,
      colors2: defaultProps2,
      edit_id: {
        edit_id: ''
      },
      column: false,
      asc: '',
      desc: '',
      sortState: '',

      id: true,
      name: true,
      color: true,
      created_at: true,

      search: {
        id: '',
        name: '',
        color: '',
        created_at: '',
        not_id: '',
        not_name: '',
        not_color: '',
        not_created_at: ''
      },

      add: {
        name: ''
        // color: '',
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    tags () {
      return this.$store.getters.tags
    },

    tag_color () {
      return this.colors.hex
    },

    tag_color2 () {
      return this.colors2.hex
    },

    orderedTags () {
      if (this.sortState === '' || this.sortState === 'asc') {
        return _.orderBy(this.tags, this.asc)
      } else if (this.sortState === 'desc') {
        return _.orderBy(this.tags, this.desc).reverse()
      }
    }
  },
  methods: {
    onChange (val) {
      this.colors = val
    },

    onChange2 (event, list) {
      list.color = event.hex
    },

    chrome () {
      this.condition = !this.condition
    },

    chrome2 () {
      this.condition2 = !this.condition2
    },

    switchV (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.name = false
      this.color = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.name = true
      this.color = true
      this.created_at = true
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === 'desc') {
        this.sortState = 'asc'
        this.asc = header
      } else if (this.sortState === 'asc') {
        this.sortState = 'desc'
        this.desc = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    editTag (list) {
      this.edit_id.edit_id = list.id
    },

    postTag () {
      this.$store.dispatch('postTag', {
        add: this.add,
        color: this.tag_color
      })
    },

    deleteTag (list) {
      this.$store.dispatch('deleteTag', list)
    },

    cancelTag (list) {
      this.$store.dispatch('cancelTag', {
        list: list,
        edit_id: this.edit_id
      })
    },

    patchTag (list) {
      this.$store.dispatch('patchTag', {
        list: list,
        edit_id: this.edit_id
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  padding: 0;
  outline: 0;
  border: none;
  font-size: 12px;
}
.index-box {
  height: calc(100vh - 190px);
  overflow: scroll;
  margin-top: 10px;
}
.del {
  text-align: center;
  cursor: pointer;
  width: 80px;
  &:hover {
    background: black;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// TagsIndex.vue?72ffc418